import { Box, Card, CardContent, Dialog, Stack, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import React from "react";

export default function ModalComponent(props){
    const paperSx = props.fullScreen
        ? {
            position: "relative",
            width: "100%",
            height: "calc(100vh - 200px)",
            borderRadius: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }
        : {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            maxHeight: "calc(100vh - 200px)",
          };
    return(
        <Dialog
        
        maxWidth={props.maxWidth ?? "auto"}
        fullWidth={Boolean(props.fullWidth)}
        scroll={props.scroll ?? "paper"}
        PaperProps={{sx: paperSx}}
        fullScreen={Boolean(props.fullScreen)}
        {...props}
        onClose={props.handleClose}
            >
            <Card
                sx={{
                    p: props.fullScreen ? 1 : { xs: 2, md: 3 },
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                }}
            >
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ flex: "0 0 auto" }}
                >
                    {props.hideTitle !== true && <Typography sx={props.titleStyle} variant="modalTitle">
                        {props.title}
                    </Typography>}
                    {props.hideClose !== true && (
                        <Box
                            onClick={props.handleClose}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                width: 32,
                                height: 32,
                                borderRadius: 1,
                                "&:hover": { bgcolor: "action.hover" },
                            }}
                            aria-label="Close dialog"
                            role="button"
                        >
                            <CloseIcon
                                sx={{
                                    width: { md: 20, xs: 18 },
                                    height: { md: 20, xs: 18 },
                                    color: "text.primary",
                                }}
                            />
                        </Box>
                    )}
                </Stack>
                <Box
                    sx={{
                        flex: "1 1 auto",
                        overflowY: "auto",
                        minHeight: 0,
                        pr: 0.5,
                        scrollbarWidth: "thin", // Firefox
                        scrollbarColor: "rgba(0,0,0,0.25) transparent",
                        "&::-webkit-scrollbar": {
                            width: 8,
                        },
                        "&::-webkit-scrollbar-track": {
                            background: "transparent",
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "rgba(0,0,0,0.22)",
                            borderRadius: 999,
                            border: "2px solid transparent",
                            backgroundClip: "content-box",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                            backgroundColor: "rgba(0,0,0,0.32)",
                        },
                    }}
                >
                    {props.children}
                </Box>
            </Card>
        </Dialog>
    )
}